import type { ErrorCodes } from 'chessboard/model/error/types';

/**
 * ChessError class.
 */
export class ChessError extends Error {
  public code: ErrorCodes;

  public data: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  /**
   * Constructor.
   */
  public constructor({ code, message, data }: { code: ErrorCodes; message: string; data?: any }) {
    super(message);

    this.code = code;
    this.data = data;
    this.message = message;
    this.name = 'ChessError';
  }
}
